module.exports = __webpack_public_path__ + "assets/img/panel-active.711abe75.svg";